// src/Components/Chat/utils/formatarMensagemWhatsApp.jsx
import React from 'react';

/**
 * Converte:
 *  - *texto* => <strong>texto</strong>
 *  - \n => <br />
 */
export function renderizarMensagemWhatsApp(texto) {
    if (!texto) return null;

    // quebra em linhas
    const linhas = texto.split(/\r?\n/);

    return linhas.map((linha, indexLinha) => (
        <React.Fragment key={indexLinha}>
            {indexLinha > 0 && <br />}

            {aplicarNegrito(linha)}
        </React.Fragment>
    ));
}

// Trata *negrito* dentro de uma linha
function aplicarNegrito(linha) {
    // divide a linha em pedaços, separando os trechos *assim*
    const partes = linha.split(/(\*[^*]+\*)/g);

    return partes.map((parte, indexParte) => {
        // se a parte começa e termina com *, considera negrito
        if (parte.startsWith('*') && parte.endsWith('*') && parte.length > 2) {
            const conteudo = parte.slice(1, -1); // remove as estrelas
            return <strong key={indexParte}>{conteudo}</strong>;
        }

        // texto normal
        return <React.Fragment key={indexParte}>{parte}</React.Fragment>;
    });
}
